import { may, type CanHolder } from "../../lib/access";

/**
 * Postmortem affordances (ADR-API-09: the server re-checks every write),
 * answered by the server's `can` ([F-027]): the incident's for the postmortem
 * and its tasks as a whole, each task's own for its status.
 */

/** May create and edit the postmortem (`postmortem.edit`, the incident's Owner). */
export function canEditPostmortem(incident: CanHolder): boolean {
  return may(incident, "postmortem.edit");
}

/** May create and edit follow-up tasks (`followup.edit`, the incident's Owner). */
export function canEditFollowups(incident: CanHolder): boolean {
  return may(incident, "followup.edit");
}

/**
 * May change this task's status (`followup.status`: its assignee or the
 * incident's Owner, holding Bearbeiter or Incident Owner). Deliberately not
 * gated on the incident status: follow-up tasks are tracked after the
 * incident closes (US-007), and the server imposes no status gate either.
 */
export function canChangeTaskStatus(task: CanHolder): boolean {
  return may(task, "followup.status");
}
